import { useAuth } from '@/auth/token-store';

/**
 * Whether the active clinic is billing read-only right now (an ended trial,
 * an unpaid invoice): `/auth/me`'s `activeClinicAccess`, the same source the
 * billing banner reads. Every write is then refused with 402, so a suggestion
 * that leads to one — a draft, «انجام دادم», a form to fill — is a promise
 * the panel cannot keep. `false` while unknown: the server's 402 is the gate,
 * this only decides what is offered.
 *
 * Not to be confused with a tips response's `readOnly`, which means a support
 * session is viewing the panel as this user.
 */
export function useClinicReadOnly(): boolean {
  const { activeClinicAccess } = useAuth();
  return activeClinicAccess !== null && !activeClinicAccess.writesAllowed;
}
